import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {FOLIO_COLUMN_GAP, FOLIO_LINE_COLUMNS, FOLIO_ROW_HEIGHT, FolioCellBox, FolioCellText} from "./FolioCellBox";
import {FolioFormat} from "./folioFormat";
import {NOT_APPLICABLE} from "./FolioLineRow";

interface Props {
    /** The tip the guest signed. */
    cents: number
    format: FolioFormat
}

/**
 * The tip the guest signed, until Confirm and charge posts it: after the lines, read as the posted tip
 * line will be - "—" for its time, minutes and VAT, one at the amount -, but faded, under the staff
 * word "Tip" (the posted line takes the tip service's name, in the guest's language) with when it is
 * added. Display only, never part of the draft: not saved, not editable, no menu, not printed. On
 * Confirm the real line takes its place, lit as it arrives.
 */
const FolioPendingTipRow = ({cents, format}: Props) => {
    const {t} = useTranslation();
    const amount = format.amount(cents);

    return (
        <Box
            data-pending-tip
            sx={{
                display: 'grid',
                gridTemplateColumns: FOLIO_LINE_COLUMNS,
                columnGap: FOLIO_COLUMN_GAP,
                alignItems: 'center',
                height: FOLIO_ROW_HEIGHT,
                borderBottom: 1,
                borderColor: 'divider',
                // Faded, the amount still legible
                opacity: 0.5,
            }}
        >
            <FolioCellBox>
                <FolioCellText value={t('Tip')}/>
                <FolioCellText value={t('Added when you confirm')} muted/>
            </FolioCellBox>
            <FolioCellBox align={'right'}><FolioCellText value={NOT_APPLICABLE}/></FolioCellBox>
            <FolioCellBox align={'right'}><FolioCellText value={NOT_APPLICABLE}/></FolioCellBox>
            <FolioCellBox align={'right'}><FolioCellText value={'1'}/></FolioCellBox>
            <FolioCellBox align={'right'} sx={{fontVariantNumeric: 'tabular-nums'}}><FolioCellText value={amount}/></FolioCellBox>
            <FolioCellBox align={'right'}><FolioCellText value={NOT_APPLICABLE}/></FolioCellBox>
            <FolioCellBox align={'right'} sx={{fontVariantNumeric: 'tabular-nums'}}><FolioCellText value={amount}/></FolioCellBox>
        </Box>
    );
};

export default FolioPendingTipRow;
